"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DotCount = void 0;
var _react = _interopRequireWildcard(require("react"));
var _framerMotion = require("framer-motion");
require("./DotCount.css");
var _dot = require("@cbhq/cds-common/motion/dot");
var _dot2 = require("@cbhq/cds-common/tokens/dot");
var _parseDotCountMaxOverflow = require("@cbhq/cds-common/utils/parseDotCountMaxOverflow");
var _NewAnimatePresence = require("../animation/NewAnimatePresence");
var _usePalette = require("../hooks/usePalette");
var _useMotionProps = require("../motion/useMotionProps");
var _TextCaption = require("../typography/TextCaption");
var _eventHandlers = require("../utils/eventHandlers");
var _dotStyles = require("./dotStyles");
const _excluded = ["children", "pin", "variant", "count", "max", "testID", "accessibilityLabel", "overlap"];
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
const dotCountContentLinaria = "cds-dotCountContentLinaria-de7m039";
const DotCount = /*#__PURE__*/(0, _react.memo)(_ref => {
  let children = _ref.children,
    pin = _ref.pin,
    _ref$variant = _ref.variant,
    variant = _ref$variant === void 0 ? 'negative' : _ref$variant,
    count = _ref.count,
    max = _ref.max,
    testID = _ref.testID,
    accessibilityLabel = _ref.accessibilityLabel,
    overlap = _ref.overlap,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  const palette = (0, _usePalette.usePalette)();
  const pinStyles = (0, _dotStyles.getTransform)(pin, overlap);
  const styles = (0, _react.useMemo)(() => {
    return Object.assign({
      backgroundColor: palette[variant],
      borderColor: palette.secondary
    }, pinStyles);
  }, [palette, pinStyles, variant]);
  const motionProps = (0, _useMotionProps.useMotionProps)({
    enterConfigs: [_dot.dotOpacityEnterConfig, _dot.dotScaleEnterConfig],
    exitConfigs: [_dot.dotOpacityExitConfig, _dot.dotScaleExitConfig],
    exit: 'exit'
  });
  return /*#__PURE__*/_react.default.createElement("div", _extends({
    "aria-label": accessibilityLabel,
    className: _dotStyles.dotRootContainerStyles,
    "data-testid": testID
  }, props), children, /*#__PURE__*/_react.default.createElement(_NewAnimatePresence.NewAnimatePresence, null, count > 0 && /*#__PURE__*/_react.default.createElement(_framerMotion.m.div, _extends({}, motionProps, {
    className: dotCountContentLinaria,
    "data-testid": "dotcount-outer-container",
    onClick: _eventHandlers.handlePreventPropagation,
    style: styles
  }), /*#__PURE__*/_react.default.createElement(_TextCaption.TextCaption, {
    align: "center",
    as: "p",
    color: "primaryForeground"
  }, (0, _parseDotCountMaxOverflow.parseDotCountMaxOverflow)(count, max)))));
});
exports.DotCount = DotCount;